import React from 'react';
import { useQnAContext } from './contexts/QnAContext';
import styles from './QnAWidget.module.scss';
import { QnAWidgetIcon } from './QnAWidgetIcon';
import { QnAWidgetWindow } from './QnAWidgetWindow';

export function QnAWidget() {
  const { isExpanded, toggleExpanded } = useQnAContext();

  return (
    <div className={`${styles.widgetContainer} ${isExpanded ? styles.expanded : ''}`}>
      <QnAWidgetWindow />
      <QnAWidgetIcon onClick={toggleExpanded} />
    </div>
  );
}
